/**
 * @module events/types/touchStart
 */

/**
 * @type {string}
 */
export default 'touchstart'
